// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"style-module__socialMedia___310uM","socialMediaLinks":"style-module__socialMediaLinks___a5LQi"};